import { apiFetch } from "./client";

export type PdfVorlageInfo = {
  doc_type: string;
  label: string;
  builtin_dateiname: string | null;
  builtin_vorhanden: boolean;
  custom_vorlagen: string[];
  auswahl: string | null;
};

export async function listPdfVorlagen(): Promise<PdfVorlageInfo[]> {
  return apiFetch<PdfVorlageInfo[]>("/api/pdf-vorlagen");
}

export async function uploadPdfVorlage(docType: string, file: File): Promise<{ dateiname: string }> {
  const fd = new FormData();
  fd.append("datei", file);
  return apiFetch<{ dateiname: string }>(`/api/pdf-vorlagen/${encodeURIComponent(docType)}`, {
    method: "POST",
    body: fd,
  });
}

export async function deletePdfVorlage(docType: string, name: string): Promise<void> {
  await apiFetch(`/api/pdf-vorlagen/${encodeURIComponent(docType)}/files/${encodeURIComponent(name)}`, {
    method: "DELETE",
  });
}

export async function setPdfVorlagenAuswahl(docType: string, dateiname: string | null): Promise<void> {
  await apiFetch(`/api/pdf-vorlagen/${encodeURIComponent(docType)}/auswahl`, {
    method: "PUT",
    body: { dateiname },
  });
}

export function pdfVorlageBuiltinUrl(docType: string): string {
  return `/api/pdf-vorlagen/${encodeURIComponent(docType)}/builtin`;
}

export function pdfVorlageCustomUrl(docType: string, name: string): string {
  return `/api/pdf-vorlagen/${encodeURIComponent(docType)}/files/${encodeURIComponent(name)}`;
}

export async function downloadPdfVorlage(url: string, suggestedName: string): Promise<void> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Download fehlgeschlagen (HTTP ${res.status}).`);
  const blob = await res.blob();
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objUrl;
  a.download = suggestedName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objUrl);
}
